import { useEffect, useMemo, useState } from "react";
import { getFirstLetterCapital, getInitials, generateTrackingObject } from "@core/global/global-country-functions";
import ReactCountryFlag from "react-country-flag";
import ReactTooltip from "react-tooltip";
import { formatStringCase, getTitleCase, handleDownloadError, isJsonResponse } from "@utils/utils";
import Linkedin from "@assets/images/linkedin.svg";
import ReactTableTrademo from "@shared/trademo-datatable/react-table-trademo";
import styles from "./TableData.module.scss";
import { Form, Popover } from "react-bootstrap";
import { getFavouriteDetailsHandler, getSlugAndSetEmailHandler } from "@redux/Bookmark/bookmark.action";
import { useDispatch, useSelector } from "react-redux";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import { FavouriteSingleDeleteModal } from "@components/templates/Favourite/FavouriteSingleDeleteModal";
import axios from "axios";
import { globalAPIDictionary } from "@core/global/global-country-dictionary";
import moment from "moment";
import { navigateToProfileHandler } from "../../utils/helper";
import { loadingBookmarkData } from "@redux/Bookmark/bookmarksSlice";
import { captureException } from "@sentry/react";
import { noTags, profileType } from "../../../../utils/enum";
import { companyPayload, logisticsPayload, pendoEventType } from "../../utils/constant";
import LoadingSkeleton from "@shared/LoadingSkeleton";
import { toast } from "react-toastify";
import { trademoTrackingEvents } from "@core/global/trademo-tracking";
import getTrackingEventDictionary from "@core/dictionary/tracking-event";
import Notes from "@shared/notes";
import { setRedirectionIdsArrayHandler } from "@redux/User/userDetailsSlice";
const dynamicAvatarColors = ["#EAECF5", "#E0F2FE", "#E0EAFF", "#EBE9FE", "#FCE7F6", "#FEF0C7"];

export const TableData = ({ singleData, setSingleData, setSelectedCompanyArray, selectedCompanyArray, setShowFavModal, setShowContactModal, clearSelectedCompanies, type, payload, setPayload, perPage, setPerPage, currentpage, setCurrentPage }) => {
  const [showSingleData, setShowSingleData] = useState(false);
  const state = useSelector((state) => state.bookmarkDetails.bookmarkData);
  const redirectionIdsArr = useSelector((state) => state?.userDetails?.redirectionIdsArr ?? []);
  let paginateCount = 60;
  const userDetails = useSelector((state) => state.userDetails);
  const STARTERPLAN = userDetails?.creditDetails?.data?.find((data) => data?.is_active && data?.user_active_plan?.toLowerCase()?.includes("starter"))?.navigate === "search";
  const { userData } = useSelector((state) => state.userDetails);
  const isImpExpPersona = userData?.line_of_business === "Import" || userData?.line_of_business === "Export" || userData?.line_of_business === "Export and Import";

  const dispatch = useDispatch();

  const favouriteCompaniesColumns = useMemo(() => {
    let column = [
      {
        name: "S. No",
        selector: "serial_no",
        maxWidth: "50px !important",
        minWidth: "50px !important",
      },
      {
        name: "Added On",
        wrap: true,
        maxWidth: "100px !important",
        minWidth: "100px !important",
        selector: (row) => <div>{moment(row.created_at).format("MMM DD, YYYY")}</div>,
      },
      {
        name: "Company",
        wrap: true,
        grow: 4,
        maxWidth: "350px !important",
        minWidth: "350px !important",
        selector: (row) => (
          <div key={row?.company_id}>
            {row?.company_id && row?.company_name !== "" ? (
              <div className="d-flex justify-content-between align-items-center">
                <p
                  onClick={() => {
                    dispatch(setRedirectionIdsArrayHandler(row.company_id));
                    navigateToProfileHandler(row, type);
                    trademoTrackingEvents(getTrackingEventDictionary.dashboardFavourites + pendoEventType[type] + "navigation", { ...generateTrackingObject(`intel-${type}-favourite`), name: row.company_name });
                  }}
                  className={`${styles.favouriteCompanyText} ${redirectionIdsArr.includes(row.company_id) ? `${styles.text_visited}` : ""}`}>
                  {getFirstLetterCapital(row.company_name)}
                  {row.is_merged ? <button className={styles.merged_tag}>Merged</button> : ""}
                </p>
                <div className="cursor-pointer d-flex align-items-center">
                  {row?.contactsCount && !row.is_merged ? (
                    <OverlayTrigger
                      trigger="click"
                      key={"right"}
                      placement={"right"}
                      rootClose
                      overlay={
                        <Popover id={`popover-positioned-right`}>
                          <Popover.Content className={styles.popoverBody}>
                            <AddressBookCard row={row} type={type} />
                          </Popover.Content>
                        </Popover>
                      }>
                      <span className="px-1 d-flex align-items-center mr-1">
                        <span className={`material-symbols-outlined ${styles.favIcon}`}>perm_contact_calendar</span>
                        <span>{row.contactsCount}</span>
                      </span>
                    </OverlayTrigger>
                  ) : (
                    ""
                  )}
                  <Notes comingFrom="dashboard" count={row.notes_count} id={row.id} profileType={type} />

                  {row?.notification_count && !row.is_merged ? (
                    <OverlayTrigger
                      trigger="click"
                      key={"right"}
                      placement={"right"}
                      rootClose
                      overlay={
                        <Popover id={`popover-positioned-right`}>
                          <Popover.Content className={styles.popoverBody}>
                            <DownloadCard row={row} type={type} />
                          </Popover.Content>
                        </Popover>
                      }>
                      <span className="px-1 d-flex align-items-center">
                        <span className={`material-symbols-outlined ${styles.favIcon}`}>notifications</span> <span>{row?.notification_count}</span>
                      </span>
                    </OverlayTrigger>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            ) : (
              <span className={styles.noDataText}>NA</span>
            )}
          </div>
        ),
      },
      {
        name: "Tags",
        wrap: true,
        grow: 8,
        maxWidth: "250px !important",
        minWidth: "250px !important",
        selector: (row) => (
          <div
            onClick={() => {
              setShowFavModal(true);
              setSingleData(row);
              trademoTrackingEvents(getTrackingEventDictionary.dashboardFavourites + pendoEventType[type] + "add_edit_tag", { ...generateTrackingObject(`intel-${type}-favourite`) });
            }}>
            {row?.tags?.length && row.tags.filter((filterKey) => filterKey !== noTags).length ? (
              <div className="d-flex align-items-center flex-wrap">
                {row?.tags?.map((item) => (
                  <span key={item} data-tip={item} data-for="datatipID" className={`${styles.simpleTag} mr-1`}>
                    {item ? item.slice(0, 30) : ""}
                    {!!item && item.length > 30 ? "..." : ""}
                  </span>
                ))}
                {row?.tags?.length > 0 && row.tags.filter((filterKey) => filterKey !== noTags).length > 0 ? (
                  <span className={`${styles.simpleEditTag} cursor-pointer`}>
                    <p className="m-0">edit</p>
                  </span>
                ) : (
                  ""
                )}
              </div>
            ) : (
              <span className={`d-flex align-items-center cursor-pointer ${styles.simpleEditTag}`}>add tag</span>
            )}
            <ReactTooltip className="trademo-tooltip" textColor="#FFFFFF" place="top" id="datatipID" />
          </div>
        ),
      },
      {
        name: "Country",
        wrap: true,
        maxWidth: "150px",
        minWidth: "150px",
        selector: (row) => (
          <div>
            {row?.company_country ? (
              <div className="text-capitalize">
                <ReactCountryFlag className="trademo-search-flag mr-2" countryCode={row.country_code} svg />
                {getFirstLetterCapital(row.company_country) + " "}
              </div>
            ) : (
              <span className={styles.noDataText}>NA</span>
            )}
          </div>
        ),
      },
      {
        name: "Actions",
        wrap: true,
        selector: (row) => (
          <div className="cursor-pointer d-flex">
            {!row.is_merged && !STARTERPLAN ? (
              <span
                onClick={() => {
                  if (selectedCompanyArray.length === 0) {
                    setSingleData(row);
                    setShowContactModal(true);
                    trademoTrackingEvents(getTrackingEventDictionary.dashboardFavourites + pendoEventType[type] + "company_request_contact", { ...generateTrackingObject(`intel-${type}-favourite`), name: row.company_name });
                  }
                }}
                className="mr-2">
                <ReactTooltip className="trademo-tooltip" textColor="#FFFFFF" place="top" id="fetchContats" />
                <span data-tip={"Fetch Contacts"} data-for="fetchContats" className={`material-symbols-outlined ${styles.favIcon}`}>
                  contact_phone
                </span>
              </span>
            ) : (
              <></>
            )}
            <span
              onClick={() => {
                if (selectedCompanyArray.length === 0) {
                  setSingleData(row);
                  setShowSingleData(true);
                  trademoTrackingEvents(getTrackingEventDictionary.dashboardFavourites + pendoEventType[type] + "delete", { ...generateTrackingObject(`intel-${type}-favourite`), name: row.company_name });
                }
              }}
              className="mx-2">
              <ReactTooltip className="trademo-tooltip" textColor="#FFFFFF" place="top" id="deleteFavourite" />
              <span data-tip={"Remove"} data-for="deleteFavourite" className={`material-symbols-outlined ${styles.favIcon}`}>
                delete
              </span>{" "}
            </span>
          </div>
        ),
      },
    ];

    if (isImpExpPersona) {
      column.splice(4, 0, {
        name: "Category",
        wrap: true,
        maxWidth: "150px",
        minWidth: "150px",
        selector: (row) => <div className="tw-capitalize">{row.company_user_pov ?? "-"}</div>,
      });
    }
    if (type === profileType.logistics) {
      column.splice(3, 0, {
        name: "Type",
        wrap: true,
        maxWidth: "270px",
        minWidth: "270px",
        selector: (row) => (
          <div className="d-flex">
            {row?.type?.length &&
              row.type.map((type) => (
                <span key={type} className={styles.pill}>
                  {type}
                </span>
              ))}
          </div>
        ),
      });
    }
    if (type === profileType.company) {
      column.splice(5, 0, {
        name: "Alert",
        wrap: true,
        maxWidth: "100px",
        minWidth: "100px",
        selector: (row) => (
          <div className="d-flex">
            {!row.is_merged ? (
              <span className={row.is_email_alert ? "twolevel-checkbox" : "twolevel-checkbox-uncheck"}>
                <Form.Check
                  type="switch"
                  id={`custom-alert-switch-` + row.company_id}
                  checked={row.is_email_alert}
                  onChange={(e) => {
                    updateEmailAlertHandler(row, e.target.checked);
                    trademoTrackingEvents(getTrackingEventDictionary.dashboardFavourites + pendoEventType[type] + "set_email_alert_switch", { ...generateTrackingObject(`intel-${type}-favourite`), alert: e.target.checked, name: row.company_name });
                    if (e.target.checked) {
                      toast.success("Email alert for the company has been successfully enabled.");
                    } else {
                      toast.success("Email alert for the company has been disabled. You can enable the alerts to take informative decisions on the company.");
                    }
                  }}
                />
              </span>
            ) : (
              <></>
            )}
          </div>
        ),
      });
    }

    return column;
  }, [type, redirectionIdsArr]);

  useEffect(() => {
    setCurrentPage(1);
  }, [payload]);

  const updateEmailAlertHandler = (row, checked) => {
    dispatch(getSlugAndSetEmailHandler({ data: { ...row, checked: checked }, payload }));
  };

  const handleTrademoTablePageChange = (page, perPage) => {
    setPerPage(perPage);
    setCurrentPage(page);
    const requiredValue = page * perPage;
    if (!(!!state?.data[requiredValue + 1] && state?.data[requiredValue + 1] !== "") && requiredValue + 1 < state?.filteredFavouriteDataCount) {
      let payloadClone = { ...payload };
      payloadClone.from = payloadClone.from + paginateCount;
      dispatch(loadingBookmarkData());
      dispatch(getFavouriteDetailsHandler({ payload: payloadClone, type: "pagination" }));
      setPayload(payloadClone);
    }
  };

  return (
    <div className="mt-3">
      <ReactTableTrademo
        columns={favouriteCompaniesColumns}
        data={state?.data || []}
        onSelectedRowsChange={(data) => setSelectedCompanyArray(data)}
        paginationTotalRows={state?.filteredFavouriteDataCount || 0}
        clearSelectedRows={clearSelectedCompanies}
        paginationPerPage={perPage}
        paginationDefaultPage={currentpage}
        selectedData={selectedCompanyArray}
        onChangeRowsPerPage={(data) => {
          setPerPage(data);
        }}
        onTableObjectChange={(data) => {
          setPerPage(data.perPage);
          setCurrentPage(data.currentPage + 1);
        }}
        onChangePage={(page, perPage) => {
          handleTrademoTablePageChange(page, perPage);
        }}
        hideSorting={true}
        hideBorder={true}
      />
      {showSingleData ? <FavouriteSingleDeleteModal setCurrentPage={setCurrentPage} setSingleData={setSingleData} setPayload={setPayload} type={type} payload={type === profileType.logistics ? logisticsPayload : companyPayload} selectedCompany={singleData} showSingleData={showSingleData} setShowSingleData={setShowSingleData} /> : ""}
    </div>
  );
};

const AddressBookCard = ({ row, type }) => {
  const [addressBookData, setAddressBookData] = useState([]);
  const [loading, setLoading] = useState(true);
  const state = useSelector((state) => state.userDetails.userToken);

  useEffect(() => {
    getAddressBookDetails();
    trademoTrackingEvents(getTrackingEventDictionary.dashboardFavourites + pendoEventType[type] + "company_view_contact", { ...generateTrackingObject(`intel-${type}-favourite`), name: row.company_name });
  }, []);

  const getAddressBookDetails = async () => {
    setLoading(true);
    try {
      let {
        data: { data },
      } = await axios.post(globalAPIDictionary.getAddressDetails, {
        type: type,
        Company_id: row.company_id,
        from: 0,
      });
      setAddressBookData(data ? data : []);
    } catch (error) {
      captureException(error);
    } finally {
      setLoading(false);
    }
  };

  const downloadAdressDetails = () => {
    try {
      let file_name = "AddressBookContact_" + moment().format("DD-MM-YYYY") + "_" + new Date().getTime();
      const downloadShipmentApiUrl = globalAPIDictionary.getDownloadAllContactInAddressBook;
      const request = new XMLHttpRequest();
      request.open("POST", downloadShipmentApiUrl, true);
      request.setRequestHeader("Content-Type", "application/x-www-form-urlencoded; charset=UTF-8");
      request.responseType = "blob";
      request.setRequestHeader("sessionId", state?.session_id);
      request.setRequestHeader("ssoToken", state?.sso_token);
      request.onload = function () {
        if (request.status === 200 && !isJsonResponse(request)) {
          const contentTypeHeader = request.getResponseHeader("Content-Type");
          const file = new Blob([this.response], { type: contentTypeHeader });
          const url = window.URL.createObjectURL(file);
          const a = document.createElement("a");
          document.body.appendChild(a);
          a.href = url;
          a.download = file_name + ".xlsx";
          a.click();
        } else {
          handleDownloadError(request);
        }
      };
      request.send(
        JSON.stringify({
          bulk_download: false,
          from_date: "2020-04-1",
          to_date: "2024-04-29",
          search: "",
          contacts: addressBookData,
        }),
        this
      );
    } catch (err) {
      captureException(err);
      toast.error("Something went wrong!");
    }
  };

  const avatarBgColors = useMemo(() => {
    let colorArr = [];
    for (let i = 0; i < dynamicAvatarColors.length; i++) {
      colorArr.push(dynamicAvatarColors[Math.floor(Math.random() * dynamicAvatarColors.length)]);
    }
    return colorArr;
  }, []);

  return (
    <div>
      <div>
        {!loading ? (
          <button onClick={downloadAdressDetails} className={styles.addressbookButton}>
            <span className={`material-symbols-outlined ${styles.favIcon}`}>cloud_download</span> <span className="ml-1">Download</span>
          </button>
        ) : (
          ""
        )}
        {!loading ? (
          <div className={styles.contacts_card_container}>
            {addressBookData.map((item, index) => (
              <>
                <div key={item?.contact_id} className={styles.contacts_card}>
                  <div>
                    <div className={styles.card_header}>
                      <div className={styles.name_container}>
                        {item.profilePicUrl ? (
                          <img src={item.profilePicUrl} className={styles.name_image} alt={getInitials(item.fullName)} />
                        ) : (
                          <div className={styles.name_icon} style={{ backgroundColor: avatarBgColors[index] }}>
                            {(item.fullName && getInitials(item.fullName)) || "NA"}
                          </div>
                        )}
                        <div className={styles.name}>
                          {(item.fullName && formatStringCase(item.fullName.slice(0, 45), false, true)) || "NA"}
                          {item?.fullName?.length > 45 && "..."}
                          {item?.location && item?.location?.length && <div className={styles.contact_data_label}>{item.location}</div>}
                        </div>
                      </div>
                    </div>
                    {(item.jobProfile || item.seniority || item.department) && (
                      <>
                        {item.jobProfile && (
                          <div className={`${styles.contact_data} ${styles.profile_header}`}>
                            <span className={styles.contact_data_label}>Job Title</span>
                            <span data-for={`job_profile${item.contact_id}`} data-tip={item.jobProfile.length > 30 ? getTitleCase(item.jobProfile) : ""} className={styles.contact_data_value}>
                              {formatStringCase(item.jobProfile.slice(0, 30), false, true)}
                              {item.jobProfile.length > 30 && "..."}
                            </span>
                            <ReactTooltip className="trademo-tooltip" backgroundColor="#8C8C8C" textColor="#FFFFFF" place="bottom" id={`job_profile${item.contact_id}`} />
                          </div>
                        )}
                        {item.seniority && (
                          <div className={styles.contact_data}>
                            <span className={styles.contact_data_label}>Management Level</span>
                            <span data-for={`management_level${item.contact_id}`} data-tip={item.seniority.length > 30 ? getTitleCase(item.seniority) : ""} className={styles.contact_data_value}>
                              {formatStringCase(item.seniority.slice(0, 30), false, true)}
                              {item.seniority.length > 30 && "..."}
                            </span>
                            <ReactTooltip className="trademo-tooltip" backgroundColor="#8C8C8C" textColor="#FFFFFF" place="bottom" id={`management_level${item.contact_id}`} />
                          </div>
                        )}
                        {item.department && (
                          <div className={styles.contact_data}>
                            <span className={styles.contact_data_label}>Department</span>
                            <span data-for={`department${item.contact_id}`} data-tip={item.department.length > 30 ? getTitleCase(item.department) : ""} className={styles.contact_data_value}>
                              {formatStringCase(item.department.slice(0, 30), false, true)}
                              {item.department.length > 30 && "..."}
                            </span>
                            <ReactTooltip className="trademo-tooltip" backgroundColor="#8C8C8C" textColor="#FFFFFF" place="bottom" id={`department${item.contact_id}`} />
                          </div>
                        )}
                      </>
                    )}
                    {((item.email && item.isEmailViewed && Array.isArray(item.email) && item.email?.[0]) || (item.phone && item.isPhoneViewed && Array.isArray(item.phone) && item.phone?.[0]) || (item.linkedin_url && item.isLinkedInViewed)) && (
                      <>
                        <div className={styles.subHeader}>Contact info</div>
                        {item.email && item.isEmailViewed && Array.isArray(item.email) && item.email?.[0] && (
                          <div className={styles.contact_email}>
                            <svg className={styles.contacts_icon} xmlns="http://www.w3.org/2000/svg" fill="#667085" height="12" viewBox="0 -960 960 960" width="14">
                              <path d="M145.087-145.869q-32.507 0-55.862-23.356-23.356-23.355-23.356-55.862v-509.826q0-32.74 23.356-56.262 23.355-23.521 55.862-23.521h669.826q32.74 0 56.262 23.521 23.521 23.522 23.521 56.262v509.826q0 32.507-23.521 55.862-23.522 23.356-56.262 23.356H145.087ZM480-443.912l334.913-223v-68.001L480-516.913l-334.913-218v68.001l334.913 223Z" />
                            </svg>
                            {item.email?.[0]}
                            {item.email.length > 1 && (
                              <>
                                <span data-for={`email_count${item.contact_id}`} data-tip={item.email.slice(1).join(", ")} className={styles.email_count}>
                                  +{item.email.length - 1}
                                </span>
                                <ReactTooltip className="trademo-tooltip" backgroundColor="#8C8C8C" textColor="#FFFFFF" place="bottom" id={`email_count${item.contact_id}`} />
                              </>
                            )}
                          </div>
                        )}
                        {item.phone && item.isPhoneViewed && Array.isArray(item.phone) && item.phone?.[0] && (
                          <div className={styles.contact_email}>
                            <svg className={styles.contacts_icon} fill="#667085" xmlns="http://www.w3.org/2000/svg" height="12" viewBox="0 -960 960 960" width="14">
                              <path d="M796.13-105.869q-119.391 0-242.435-57.13-123.043-57.131-227.739-161.827-105.261-105.261-162.674-228.587-57.413-123.326-57.413-242.152 0-24.653 16.957-41.892 16.956-17.239 41.609-17.239h140q23.609 0 38.979 13.674 15.37 13.674 21.065 37.718l27 116.956q3.131 20.783-1.065 37.087-4.196 16.305-16.718 27.696l-102.261 97.609q23.739 39.478 50.478 74.086 26.739 34.609 60.044 66.348 34.739 36.304 71.499 64.695 36.761 28.392 76.109 49l97.826-99.696q13.957-14.956 31.479-20.087 17.521-5.13 36.739-.869l107.695 24.304q24.044 6.826 37.718 23.348 13.674 16.522 13.674 40.001v138.391q0 24.653-17.239 41.609-17.239 16.957-41.327 16.957Z" />
                            </svg>
                            {item.phone?.[0]}
                            {item.phone.length > 1 && (
                              <>
                                <span data-for={`phone_num_count${item.contact_id}`} data-tip={item.phone.slice(1).join(", ")} className={styles.phone_num_count}>
                                  +{item.phone.length - 1}
                                </span>
                                <ReactTooltip className="trademo-tooltip" backgroundColor="#8C8C8C" textColor="#FFFFFF" place="bottom" id={`phone_num_count${item.contact_id}`} />
                              </>
                            )}
                          </div>
                        )}
                        {item.linkedin_url && item.isLinkedInViewed && (
                          <div className={styles.contact_phone}>
                            <div>
                              <img src={Linkedin} alt="linkedin" className={styles.contacts_icon} />
                            </div>
                            <a href={item.linkedin_url} className={styles.trademo_link} target="_blank" rel="noreferrer">
                              {item.linkedin_url}
                            </a>
                          </div>
                        )}
                      </>
                    )}
                  </div>
                </div>
              </>
            ))}
          </div>
        ) : (
          <div className="mt-2">
            <LoadingSkeleton lines={10} lineHeight={"300px"} width={"100%"} shape="rectangle" widthArr={["100%"]} />
          </div>
        )}
      </div>
    </div>
  );
};

const DownloadCard = ({ row, type }) => {
  const [downloadDetails, setDownloadDetails] = useState([]);

  useEffect(() => {
    setDownloadDetails(row?.download_history);
    trademoTrackingEvents(getTrackingEventDictionary.dashboardFavourites + pendoEventType[type] + "company_alert_download", { ...generateTrackingObject(`intel-${type}-favourite`), name: row.company_name });
  }, []);

  const downloadExcel = (data) => {
    if (!!data && data !== "") {
      const params = {
        file_name: data,
      };
      const apiUrl = globalAPIDictionary.getDownloadShipments;
      axios.get(apiUrl, { params }).then(
        (res) => {
          if (!!res && !!res.data && !!res.data.status && res.data.status.toLocaleUpperCase() === "SUCCESS".toLocaleUpperCase()) {
            window.open(res.data.data.file_url);
          } else {
            toast.error(res.data.message);
          }
        },
        () => {
          toast.error("Something went wrong. Please try again later!!!");
        }
      );
    } else {
      toast.error("Something went wrong. Please try again later !!!");
    }
  };

  return (
    <div>
      <div>
        {downloadDetails?.map((download) => (
          <div key={download?.sheet_url} className="d-flex align-items-center justify-content-between my-2 ">
            <div className="d-flex align-items-center">
              <img src="https://res.cloudinary.com/drzta9shk/image/upload/v1713870137/intel/icons/pdf-file_2_1_kqxole.svg" />
              <p className="mb-0 ml-1">Alert sent on {moment(download?.responseDate).format("MMM DD, YYYY")}</p>
            </div>
            <button onClick={() => downloadExcel(download?.url)} className={styles.notificationButton}>
              <img className="mr-1" src="https://res.cloudinary.com/drzta9shk/image/upload/v1657875670/intel/Importer-Exporter_Tab/leftbar_icon_download_fqdhxy.svg" />
              <span>Download</span>
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};
